import { createRouter, createWebHistory} from 'vue-router'

import MainView from '@/views/HomePage.vue';
import PortfolioViking from "@/views/PortfolioViking.vue";
import PortfolioCertegy from "@/views/PortfolioCertegy.vue";
import PortfolioThompson from "@/views/PortfolioThompson.vue";
import PortfolioNorthlink from "@/views/PortfolioNorthlink.vue";
import PortfolioIndustryGenome from "@/views/PortfolioIndustryGenome.vue";
import PortfolioGraphicDesign from "@/views/PortfolioGraphicDesign.vue";
import ProjectStarFighter from "@/views/ProjectStarFighter.vue";
import ProjectSolarWinds from "@/views/ProjectSolarWinds.vue";
import ProjectMusic from "@/views/ProjectMusic.vue";

const routes = [
    {
        path: '/',
        component: MainView
    },
    {
        path: '/portfolio/viking-cruises',
        component: PortfolioViking
    },
    {
        path: '/portfolio/certegy',
        component: PortfolioCertegy
    },
    {
        path: '/portfolio/thompson-consulting',
        component: PortfolioThompson
    },
    {
        path: '/portfolio/northlink-ferries',
        component: PortfolioNorthlink
    },
    {
        path: '/portfolio/industry-genome',
        component: PortfolioIndustryGenome
    },
    {
        path: '/portfolio/graphic-design',
        component: PortfolioGraphicDesign
    },
    {
        path: '/project/just-another-star-fighter',
        component: ProjectStarFighter
    },
    {
        path: '/project/solar-winds',
        component: ProjectSolarWinds
    },
    {
        path: '/project/music',
        component: ProjectMusic
    },
    {
        path: '/:catchAll(.*)',
        component: MainView
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                top: -window.innerHeight
            }
        }
    },
})

export default router